import React from 'react';
import { getDic } from '../../assets/i18n/dictionary';
import {
  FormRow,
  FormColumn,
  TextSmall,
  Camera,
  TextMedium,
} from '../../components';

const Step2CameraPhoto = (props) => {
  const {
    params,
    dimensions,
    configOptions,
    tryCaptureFace,
    cameraControl,
  } = props;

  const width = dimensions.width > 660 ? 640 : dimensions.width;
  const height = dimensions.height > 500 ? 480 : dimensions.height;

  return (
    <>
      <FormRow justifyContent='center' paddingTop={20}>
        <TextSmall align='center' color={configOptions.textColor}>
          {`- ${getDic("face-collector-step-2-a")}`}
        </TextSmall>
      </FormRow>
      <FormRow justifyContent='center' paddingTop={5}>
        <TextSmall align='center' color={configOptions.textColor}>
          {`- ${getDic("face-collector-step-2-b")}`}
        </TextSmall>
      </FormRow>
      <FormRow justifyContent='center' paddingTop={5}>
        <TextSmall align='center' color={configOptions.textColor}>
          {`- ${getDic("face-collector-step-2-c")}`}
        </TextSmall>
      </FormRow>
      <FormRow justifyContent='center' paddingTop={5}>
        <TextSmall align='center' color={configOptions.textColor}>
          {`- ${getDic("face-collector-step-2-d")}`}
        </TextSmall>
      </FormRow>
      {!cameraControl.cameraAvailable && (
        <FormRow justifyContent='center' paddingTop={20}>
          <TextMedium fontWeight='bold' color={configOptions.textColor}>🚫 {getDic("face-collector-step-2-e")}.</TextMedium>
        </FormRow>
      )}
      {!cameraControl.cameraAvailable && (
        <FormRow justifyContent='center' paddingTop={20}>
          <TextMedium fontWeight='bold' color={configOptions.textColor}>⚠️ {cameraControl.errorMessage || `${getDic("face-collector-step-2-f")}`}</TextMedium>
        </FormRow>
      )}
      <FormRow justifyContent='center' paddingTop={10}>
        {cameraControl.cameraAvailable && cameraControl.hasPermission && (
          <Camera
            configOptions={configOptions}
            width={width}
            height={height}
            onPhoto={i => tryCaptureFace(i)}
          />
        )}
      </FormRow>
    </>
  )
};

export default Step2CameraPhoto;
